import {
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material';
import React from 'react';
interface ITableDataAnalyticsProps {
    tables: {
        data: {
            value: number;
            value_percent: number;
            name: string;
        }[];
        total: number;
    };
}
const TableDataAnalytics: React.FC<ITableDataAnalyticsProps> = ({ tables }) => {
    return (
        <TableContainer
            component={Paper}
            sx={{
                overflowX: 'auto',
            }}
        >
            <Table
                sx={{
                    minWidth: 650,
                }}
            >
                <TableHead
                    sx={{
                        backgroundColor: '#D4E3FF',
                    }}
                >
                    <TableRow>
                        <TableCell>Đáp án trả lời</TableCell>
                        <TableCell>Tỷ lệ</TableCell>
                        <TableCell>Số lượng</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.isArray(tables?.data) &&
                        tables?.data?.map((table, index) => (
                            <TableRow key={index}>
                                <TableCell>{table.name}</TableCell>
                                <TableCell>{table.value_percent}%</TableCell>

                                <TableCell>{table.value ?? 0}</TableCell>
                            </TableRow>
                        ))}
                </TableBody>
                <TableHead
                    sx={{
                        backgroundColor: '#D4E3FF',
                    }}
                >
                    <TableCell>Tổng</TableCell>
                    <TableCell></TableCell>
                    <TableCell>{tables.total}</TableCell>
                </TableHead>
            </Table>
        </TableContainer>
    );
};

export default TableDataAnalytics;
